<template>
  <div class="auth-module">
<!--    <div class="head">-->
<!--      <svg-icon icon-class="设置" color="#666666"></svg-icon>-->
<!--      空调授权远程控制-->
<!--      <van-icon @click="isShow = !isShow" name="arrow-down" :class="{'is-show': isShow}"/>-->
<!--    </div>-->
    <div class="list-card" v-if="isShow">
      <div v-for="item in dormitoryAndOrder" :key="item.Id" class="item">
        <div :class="`${item.IsProxy ? 'proxy' : ''}`"><span>{{item.IsProxy ? '代表' : '成员'}}</span></div>
        <div>{{item.Name}}</div>
        <div>{{item.Mobile}}</div>
        <div>
          <div :style="{ backgroundColor: item.IsProxy ? '#CACACA' : (item.IsAuth ? '#19D632' : '#E78383'), borderColor: item.IsProxy ? '#CACACA' : (item.IsAuth ? '#19D632' : '#E78383') }">
            <van-switch
                size="20px"
                :disabled="item.IsProxy"
                v-model="item.IsAuth"
                @change="changeAuth(item)">
            </van-switch>
            <span class="text" :style="{textAlign: item.IsAuth ? 'left' : 'right'}">{{item.IsAuth ? '允许' : '禁止'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'authModule',
  data() {
    return{
      list: [],
      isShow: true,
      dormitoryAndOrder: []
    }
  },
  methods: {
    async getAllListByDormitoryAndOrder() {
      try {
        const { Data } = await this.$post('/BizMemberMember/AllListByDormitoryAndOrder')
        this.dormitoryAndOrder = Data
      }catch (e) {

      }
    },
    changeAuth(item){
      this.$dialog.confirm({
        title: '提示',
        message: `是否${item.IsAuth ? '开启' : '关闭'}操作空调的权限`,
      }).then(async () => {
        const params = {
          DormitoryId: item.DormitoryId,
          MemberId: item.Id,
          IsProxy: item.IsProxy,
          IsAuth: item.IsAuth
        }
        try {
          const { Data, Status, Message } = await this.$post('/BizMemberMemberAuth/Update', params)
          if (Status === 1) {
            this.$toast({
              message: Message
            })
          }
        }catch (e) {
          item.IsAuth = !item.IsAuth
        }
      }).catch(() => {
        item.IsAuth = !item.IsAuth
      })
      // this.$confirm(`是否${item.IsAuth ? '开启' : '关闭'}操作空调的权限`, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(async () => {
      //   const params = {
      //     DormitoryId: this.dialogRow.Id,
      //     MemberId: item.Id,
      //     IsProxy: item.IsProxy,
      //     IsAuth: item.IsAuth
      //   }
      //   try {
      //     const { Data, Status, Message } = await this.$post('/BizMemberAuth/Update', params)
      //     if (Status === 1) {
      //       this.$message({
      //         type: 'success',
      //         message: Message
      //       })
      //     }
      //   }catch (e) {
      //     item.IsAuth = !item.IsAuth
      //   }
      // }).catch(() => {
      //   item.IsAuth = !item.IsAuth
      // })
    }
  },
  mounted() {
    this.getAllListByDormitoryAndOrder()
  }
}

</script>

<style scoped lang="less">
.auth-module{
  color: #666666;

  .head{
    font-size: 16px;
    .svg-icon{
      font-size: 16px;
    }
    .van-icon{
      float: right;
      line-height: 26px;
      transition: all 0.2s ease-in;
    }
    .is-show{
      transform: rotate(180deg);
    }
  }
  .list-card{
    margin-top: 15px;
    width: 100%;
    border-radius: 10px;
    padding: 10px;
    background-color: #ffffff;
    .item{
      margin-bottom: 10px;
      display: flex;

      &:last-child{
        margin-bottom: 0;
      }

      >div{
        line-height: 20px;
        &:nth-child(1) {
          width: 40px;
          flex-shrink: 0;
          margin-right: 10px;
          span{
            width: 100%;
            text-align: center;
            display: inline-block;
            background-color: #409EFF;
            color: #ffffff;
            border-radius: 3px;
            font-size: 12px;
          }

          &.proxy{
            span{
              background-color: #19C82A;
            }
          }
        }
        &:nth-child(2) {
          width: 60px;
          flex-shrink: 0;
        }
        &:nth-child(3){
          width: 90px;
          flex-shrink: 0;
          color: #999999;
        }
        &:last-child{
          width: 100%;
          display: flex;
          justify-content: end;
          >div{
            width: 60px;
            position: relative;
            height: 20px;
            border-radius: 10px;
            border: 1px solid;
            display: flex;
            align-items: center;
            z-index: 1;
            .van-switch{
              width: 60px;
              z-index: 3;
              background-color: transparent;
              border: 0;
            }
            ::v-deep.van-switch--on .van-switch__node{
              transform: translateX(39px);
            }
            span{
              z-index: 2;
              display: inline-block;
              width: 60px;
              color: #ffffff;
              padding: 0 10px;
              position: absolute;
              left: 0;
              top: 0;
              line-height: 20px;
              font-size: 12px;
            }
          }

        }

      }

    }
  }
}
</style>
